import type { ru } from './ru'

export const et: Record<keyof typeof ru, string> = {
  'lang.self': 'ET',

  'dir.as_map': 'Kaardil',
  'dir.as_list': 'Loendina',
  'dir.map_none': 'Koordinaatidega asukohti pole',
  'dir.map_failed': 'Kaart ei laadinud — proovi uuesti',
  'dir.units': 'hoonet',
  'dir.pois': 'punkti',
  'dir.open': 'Ava asukoht',
  'venue.type.industrial_park': 'Tööstuspark',
  'venue.type.mall': 'Kaubanduskeskus',
  'venue.type.airport': 'Lennujaam',
  'venue.type.port': 'Sadam',
  'venue.type.ship': 'Laev',
  'venue.type.terminal': 'Terminal',
  'venue.type.cruise': 'Kruiisilaev',
  'dir.title': '{brand} — asukohtade navigaator',
  'dir.subtitle': 'Leia asukoht ja saa teekond õige punktini.',
  'dir.search': 'Otsi: nimi, aadress…',
  'dir.verified': 'Kinnitatud organisatsioon',
  'dir.empty': 'Midagi ei leitud.',
  'map.loading': 'Laadime kaarti…',
  'map.error': 'Kaart pole saadaval. Kontrolli ühendust ja värskenda lehte.',
  'map.you_are_here': 'Sa oled siin',
  'map.attribution': '© Kaardiandmed · OpenMapTiles · ODbL',
  // Ülevaate päis ja alumine leht (Aurora disain, 05.08.2026)
  'hdr.live': 'elav kaart',
  'hdr.offline': 'võrguühenduseta',
  'sheet.where_to': 'Kuhu lähed?',
  'sheet.directory': 'kõik kohad',
  'sheet.ai_hints': 'TI vihjed',
  'target.stat_time': 'aeg',
  'target.stat_way': 'teekond',
  'target.stat_levels': 'korrused',
  'target.stat_start': 'algus',
  'target.room_n': 'Ruum {code}',
  'route.arrival_at': 'kohal',
  'route.remaining': 'jäänud',
  'route.turns_n': '{n} pööret',
  'orient.step_one': 'Orientatsioon · samm 1',
  'orient.first_step_q': 'Kuhu teha esimene samm',
  'orient.acc_precise': 'Täpselt · kompass ja QR-tahvel',
  'orient.acc_approx': 'Ligikaudu · telefoni andurid',
  'orient.acc_rough': 'Umbkaudu · andureid pole',
  'orient.north': 'P',
  'orient.east': 'I',
  'orient.south': 'L',
  'orient.west': 'V',
  'follow.arrival': 'saabumine',
  'follow.recenter': 'Tagasi minu juurde',
  'follow.stat_done': 'läbitud',
  'follow.stat_left': 'jäänud',
  'follow.stat_steps': 'sammud',

  'cat.warehouse': 'Ladu',
  'cat.checkpoint': 'Pääsla',
  'cat.office': 'Dispetšeripunkt',
  'cat.dock': 'Värav',
  'cat.truck_scale': 'Autokaal',
  'cat.wc': 'WC',
  'cat.info': 'Infolett',
  'cat.entrance': 'Sissepääs',
  'cat.food': 'Toit',
  'cat.clothing': 'Mood',
  'cat.sport': 'Sport',
  'cat.tech': 'Elektroonika',
  'cat.beauty': 'Ilu',
  'cat.grocery': 'Toidupood',
  'cat.home': 'Kodu',
  'cat.service': 'Teenindus',
  'cat.loading_dock': 'Laadimisramp',
  'cat.parking': 'Parkla',
  'cat.elevator': 'Lift',
  'cat.escalator': 'Eskalaator',
  'cat.stairs': 'Trepp',

  'target.eta': '≈ {time} jalgsi · {dist}',
  'target.route': 'Teekond',
  'target.no_route': 'Teekonda ei leitud — pöördu pääslasse',
  'target.from_entrance': 'peasissepääsust',
  'route.to_floor': 'Korrusele {n}',
  'target.step_free': 'Astmeteta tee',
  'target.step_free_hint':
    'Selle sihtkohani on olemas tee ilma treppide ja astmeteta — lifti ja kaldteid mööda.',

  'travel.label': 'Kuidas liigute',
  'travel.foot': 'Jalgsi',
  'travel.vehicle': 'Autoga',
  'travel.truck': 'Veok',

  'route.ext_leg': 'sh {min} min tänavatel sissepääsuni',
  'route.go': 'Lähme',

  'floor.title': 'Korrused',
  'follow.remaining': 'Jäänud {time} · {dist}',
  'follow.next_step': 'Edasi ✓',
  'follow.floor_up_stairs': 'Minge trepist üles {n}. korrusele',
  'follow.floor_down_stairs': 'Minge trepist alla {n}. korrusele',
  'follow.floor_up_escalator': 'Sõitke eskalaatoriga üles {n}. korrusele',
  'follow.floor_down_escalator': 'Sõitke eskalaatoriga alla {n}. korrusele',
  'follow.floor_up_elevator': 'Sõitke liftiga üles {n}. korrusele',
  'follow.floor_down_elevator': 'Sõitke liftiga alla {n}. korrusele',
  'follow.floor_up': 'Minge üles {n}. korrusele',
  'follow.floor_down': 'Minge alla {n}. korrusele',
  'follow.floor_confirm': 'Olen {n}. korrusel ✓',
  'follow.floor_wrong': 'Olen veel {n}. korrusel',
  'follow.step_of': 'Samm {k}/{n}',
  'follow.arrived': 'Oled kohal',
  'follow.arrived_in': 'Kohal {time}',
  'follow.arrive_at': 'saabud ≈ {time}',
  'follow.back_route': 'Tagasitee',
  'follow.stop': 'Lõpeta',
  'follow.voice_turn': '{dist} pärast pööra {dir}',
  'follow.voice_left': 'vasakule',
  'follow.voice_right': 'paremale',
  'follow.voice_arrived': 'Oled kohal',
  'follow.alerts_silent': 'Vihjed: vaikne',
  'follow.alerts_vibrate': 'Vihjed: vibratsioon',
  'follow.alerts_voice': 'Vihjed: hääl',
  'follow.exit': 'Välju',
  'follow.details': 'Marsruudi üksikasjad',
  'follow.collapse': 'Ahenda',
  'follow.show_panel': 'Näita juhatuse paneeli',

  'anchor.toast_hint': 'kaart juba teab, kus sa oled',
  'offline.ready': 'töötab võrguta',
  'offline.cached': 'võrguta · kaart vahemälust',

  'packs.heading': 'Kaardid võrguta',
  'packs.save_venue': '💾 Salvesta ala kaart · {mb} MB',
  'packs.save_city': '🌍 Linn võrguta: {name} · {mb} MB',
  'packs.name_venue': 'Ala kaart',
  'packs.name_city': 'Linn: {name}',
  'packs.installed': '✓ Salvestatud · versioon {version}',
  'packs.downloading': 'Allalaadimine… {percent} %',
  'packs.verifying': 'Faili kontroll…',
  'packs.warming': 'Laadime fondid ja alade andmed…',
  'packs.keep_open': 'Ärge sulgege rakendust — allalaadimine käib ainult ekraanil',
  'packs.paused': 'Allalaadimine on peatatud: naaske rakendusse',
  'packs.error': 'Allalaadimine ebaõnnestus',
  'packs.error_checksum': 'Fail saabus vigasena',
  'packs.error_storage': 'Seadmes pole kaardi jaoks ruumi',
  'packs.retry': 'Proovi uuesti',
  'packs.wifi_hint': 'Parem Wi-Fi kaudu: {mb} MB',
  'packs.save_data': 'Andmesäästja on sees — allalaadimine ei pruugi õnnestuda',
  'packs.ios_install_first':
    'Kõigepealt „Lisa avakuvale“ — muidu kustutab Safari kaardi 7 päeva pärast',
  'packs.ios_steps': 'Jaga → „Lisa avakuvale“ → ava {brand} avakuvalt',
  'dock.hint': 'saab lohistada',

  'qr.dock_label': 'Skanni QR',
  'qr.title': 'QR-skanner',
  'qr.frame_hint': 'Suuna kaamera QR-koodile',
  'qr.permission_denied_title': 'Kaamerale pole juurdepääsu',
  'qr.permission_denied_body':
    'Luba kaamera brauseri seadetes (lukuikoon aadressi kõrval) või pildista kood.',
  'qr.permission_photo_btn': '📷 Pildista QR-kood',
  'qr.unavailable': 'Sellel brauseril pole kaamerale juurdepääsu — pildista kood',
  'qr.no_code_found': 'Fotolt koodi ei leitud, proovi uuesti',
  'qr.scan_again': 'Skanni uuesti',
  'qr.result_external_title': 'Link ei ole {brand} omalt',
  'qr.result_unsafe_title': 'Ebaturvaline link — automaatselt ei avata',
  'qr.result_text_title': 'Tuvastatud tekst',
  'qr.open_link': 'Ava',
  'qr.copy': 'Kopeeri',
  'qr.copied': 'Kopeeritud',

  'floor.role_target': 'siht',
  'floor.role_you': 'sina oled siin',
  'floor.role_transit': 'transiit',
  'floor.role_parking': 'parkla',

  'pos.gps': 'GPS',
  'pos.anchor': 'QR-ankru järgi',
  'pos.none': 'asukoht teadmata',

  'common.close': 'Sulge',
  'common.back': 'Tagasi',
  'common.done': 'Valmis',

  'view.iso': '3D-vaade',
  'view.map': 'Kaart',
  'iso.walk': 'Käi marsruut läbi (eelvaade)',
  'iso.overview': 'Ülevaade',
  'iso.stack': 'Kokku',
  'iso.unstack': 'Laiali',
  'iso.reset': 'Vaade',
  'iso.hint': 'Lohista — pööra · rull või näpistus — suum',

  'connector.no_alternative': 'Sellel kaardil viib üles ainult üks üleminek — teekond ei muutunud',
  'connector.row_label': 'Kuidas korruste vahel liikuda',
  'connector.wheelchair': 'Astmeteta',
  'connector.stroller': 'Lapsekäruga',
  'alarm.title': 'HÄIRE — minge punase joone järgi väljapääsu poole',
  'alarm.zones': 'ohutsoone: {n}',
  'alarm.enable_sound': 'Lülita heli sisse',
  'alarm.sound_off': 'Hääletu',
  'alarm.sound_on': 'Heli sees',
  'alarm.blink_off': 'Ära vilgu',
  'alarm.blink_on': 'Vilkumine sees',
  'connector.escalator': 'Eskalaator',
  'connector.escalator_note': 'Kiirem',
  'connector.lift': 'Lift',
  'connector.lift_note': 'Astmeteta',
  'connector.stairs': 'Trepp',
  'connector.stairs_note': 'Aktiivne',

  'car.remember': 'Jäta meelde, kus auto on',
  'car.postcard': 'Auto koha postkaart (PNG QR-iga)',
  'car.return': 'Tagasi auto juurde',
  'car.forget': 'Unusta auto',
  'car.hint': 'Skaneeri kood parkla postil või vali tsoon. Korruse automaattuvastus on rakenduses.',

  'update.ready': 'Saadaval on uus versioon',
  'update.reload': 'Uuenda',
  'unit.m': 'm',
  'unit.km': 'km',
  'unit.min': 'min',
  'unit.lessMin': '<1 min',

  'cat.gate': 'Värav',
  'cat.check_in': 'Registreerimine',
  'cat.security': 'Turvakontroll',
  'cat.baggage': 'Pagasi väljastus',
  'cat.terminal': 'Terminal',
  'cat.berth': 'Kai',
  'cat.deck': 'Tekk',
  'cat.cabin': 'Kajut',
  'cat.restaurant': 'Restoran',
  'cat.muster': 'Kogunemispunkt',
  'cat.ship': 'Laev',
  'cat.factory': 'Tootmine',
  'cat.shop': 'Pood',
  'cat.building': 'Hoone',
  'cat.hall': 'Saal',
  'cat.room': 'Ruum',
  'cat.workspace': 'Töökoht',
  'cat.rest_area': 'Puhkeala',

  'orient.board_straight': 'Näoga sildi poole — otse edasi',
  'orient.board_right': 'Näoga sildi poole — paremale',
  'orient.board_left': 'Näoga sildi poole — vasakule',
  'orient.board_back': 'Selg sildi poole — otse edasi',
  'orient.gate_straight': 'Sildist otse — juhatame edasi',
  'orient.gate_right': 'Sildist väljasõit paremale — sõitke, juhatame edasi',
  'orient.gate_left': 'Sildist väljasõit vasakule — sõitke, juhatame edasi',
  'orient.gate_back': 'Sildist tagasipööre — juhatame edasi',
  'orient.first_leg': '{dist} esimese pöördeni',
  'orient.bind': 'Pöörduge sildi poole ja siduge nool',
  'orient.bound': 'Nool seotud — õige, kuidas ka telefoni ei keeraks',
  'orient.stale': 'Nool võib olla aegunud — kontrollige sildi järgi',
  'orient.walk_hint': 'Kõndige paar sammu — täpsustame suunda',
  'orient.go': 'Lähen ✓',

  // AR-juhatus (spetsifikatsioon 13): liikumisviisi valib kasutaja; režiime
  // vahetab telefoni kalle, aus märk ütleb, milline andur juhib.
  // AR-vaate enda tekstid on laisas paketis @app/i18n/ar (strings/ar).
  'ar.choice_map': 'Kaart ja joon',
  'ar.choice_ar': 'AR-juhatus',
  'ar.new': 'UUS',
  'ar.course_btn': 'Kursi järgi',
  'ar.sensors_denied': 'Andurid pole saadaval — kaart jääb põhjasuunda',

  // «Prožektor» — tasuline esiletõst (ADR 0019). Sõna «Reklaam» ja tellija nimi
  // on alati näha: varjatud reklaam on keelatud (RekS §3).
  'promo.ad_label': 'Reklaam',
  'promo.hide': 'Peida',
  'promo.paid_by': 'Tellija: {name}',
  'promo.by_owner': 'Paigutanud objekti omanik',
  'promo.why_here': 'Miks ma seda näen',
  'promo.chip': 'Reklaam',
  'promo.ranking_title': 'Kuidas tulemuste järjekord tekib',
  'promo.ranking_intro':
    'Näitame, kuidas nimekiri koostatakse ja mis selles on tasuline. Seda nõuab ' +
    'seadus reklaami vahendavatelt platvormidelt — ja see on teie vastu aus.',
  'promo.ranking_search':
    'Otsing. Kõigepealt nime- ja kaubavasted, teie lähedust arvestades. Tasuline ' +
    'rida ei saa täpsest vastest ette minna: see tuleb kõigi sobivate järel ja ' +
    'on alati märgitud sõnaga «Reklaam».',
  'promo.ranking_map':
    'Kaart. Tasuline esiletõst on kontuur ja pehme kuma. See ei muuda objekti ' +
    'nime, kategooriat ega asukohta.',
  'promo.ranking_limit':
    'Piirid. Esile tõsta saab kõige rohkem veerandi objektidest: kui kõik on ' +
    'esile tõstetud, pole esile tõstetud keegi.',
  'promo.ranking_route':
    'Teekond. Kui te liigute, reklaami üldse ei ole — sama kehtib hädaolukorra ' + 'režiimis.',
  'promo.ranking_back': 'Tagasi kaardile',

  'door.badges': 'Selle sissepääsu kohta',
  'door.primary': 'Peasissepääs',
  'door.ramp': 'Kaldtee',
  'door.step_free': 'Astmeteta',
  'door.automatic': 'Automaatuks',
  'door.width': 'Avaus {cm} cm',

  'search.open': 'Otsing',
  'search.placeholder': 'Pood, toode või koht…',
  'search.recent': 'Hiljutised',
  'search.usually_here': 'tavaliselt saadaval siin',
  'search.not_found': '«{q}» ei leitud',
  'search.report': 'Teata asukohale',
  'search.report_sent': 'Edastasime asukoha omanikule — aitäh!',

  // ─── Hädaolukorra režiim (G4, ADR 0009); drill.*/emergency.* — strings/emergency ───
  'map.shelter_marker_aria': 'Varjumiskoht {label} · {occ}',
  'map.shelter_marker_aria_plain': 'Varjumiskoht {label}',
  // ── Вьюер «Terra» (дизайн modern-gis-logistics-application (4)) ──
  'app.tagline': 'Siseruumide viimase miili navigeerimine',
  'app.tagline_full': '{brand} — Digitaalne Giid ja Abi',
  'hdr.tagline': 'Territooriumi navigeerimine',
  'map.empty_hint': 'Puuduta kaardil hoonet või punkti',
  'map.view_3d': '3D-hooned',
  'map.view_2d': 'Tasapinnaline plaan (2D)',
  'basemap.label': 'Aluskaardi stiil',
  'basemap.dark_hint': 'Tume aluskaart',
  'basemap.cad_hint': 'Hele CAD-aluskaart',
  'legend.title': 'Territooriumi legend',
  'legend.objects': 'Objektid',
  'legend.route': 'Marsruut',
  'legend.route_network': 'Mööda ala teid',
  'legend.route_direct': 'Väljaspool teid — otse',
  'legend.safety': 'Ohutus',
  'legend.safety_points': 'Väljapääsud ja kogunemispunktid',
  'mall.error_venue': 'Selle asukoha kaart pole saadaval',
  'mall.error_not_mall': 'See asukoht ei ole kaubanduskeskus',
  'mall.shops': 'kauplust',
  'mall.sheet_toggle': 'Ava nimekiri',
  'mall.cam_rotate': 'Pööre',
  'mall.cam_tilt': 'Kalle',
  'mall.cam_zoom': 'Suum',
  'mall.cam_gap': 'Korruste vahe',
  'mall.view_2d': 'Ülalt',
  'mall.view_3d': 'Ruumiline',
  'mall.view_2d_hint': 'Korruseplaanid lapiti, kõrvuti',
  'mall.near_title': 'Lähim',
  'mall.near_wc': 'WC',
  'mall.near_lift': 'Lift',
  'mall.near_stairs': 'Eskalaator',
  'mall.near_food': 'Söök',
  'mall.near_exit': 'Väljapääs',
  'mall.mini_open': '{n} kohta · ava →',
  'mall.expand': 'lahuta',
  'mall.collapse': 'koonda',
  'mall.expand_hint': 'Näita kõiki korruseid läbi — mis on mille kohal',
  'mall.nav_pan': 'Liiguta',
  'mall.nav_orbit': 'Pööra',
  'mall.hint_camera_3d': 'Vasak — liiguta · parem või Shift+lohista — pööra · ratas — suumi',
  'mall.hint_camera_orbit': 'Lohista — pööra · ratas — suumi',
  'mall.back_to_map': 'Kaart',
  'mall.labels_name': 'Nimed',
  'mall.labels_code': 'Numbrid',
  'mall.reset_view': 'Lähtesta vaade',
  'mall.levels': 'Korrused',
  'mall.directory': 'Korruse kataloog',
  'mall.mode': 'KESKUSE REŽIIM',
  'mall.all_levels': 'Kõik korrused',
  'mall.floor_stats': '{n} kohta sellel korrusel',
  'mall.search_placeholder': 'Leia pood sellel korrusel…',
  'mall.empty': 'See korrus on tühi',
  'a2b.kicker': 'Territory Wayfinding',
  'a2b.title': 'Marsruut A → B',
  'a2b.from': 'KUST (PUNKT A)',
  'a2b.to': 'KUHU (PUNKT B)',
  'a2b.pick': 'Vali sihtkoht…',
  'a2b.distance': 'KAUGUS',
  'a2b.time': 'TEEKONNA AEG',
  'a2b.build': 'Joonista kaardile',
  'measure.kicker': 'GIS-mõõdulint',
  'measure.title': 'Mõõda kaugusi ja pindalasid',
  'measure.points': '{n} punkti',
  'measure.hint': 'Klõpsa kaardil mõõtepunktide lisamiseks',
  'measure.clear': 'Tühjenda',
  'measure.done': 'Valmis',
  'qrpass.kicker_venue': 'Objekti QR',
  'qrpass.venue_open': 'Objekti QR-kood',
  'qrpass.kicker': 'QR-navigatsioon sihtkohta',
  'qrpass.alt': 'QR-kood lingiga sihtkohale',
  'qrpass.scan_hint': 'Skaneeri telefoni kaameraga — kaart avaneb selle sihtkohaga',
  'qrpass.copy': 'Link',
  'qrpass.copied': 'Kopeeritud',
  'qrpass.share': 'Jaga',
  // Схема пути из таблички (&r=): показывается, когда карта площадки не пришла.
  'sign.route_title': 'Väljapääsu tee sildilt',
  'sign.route_hint': 'Objekti kaart ei laadinud — näitame QR-koodi salvestatud teed',
  'sign.route_start': 'Sa oled siin',
  'sign.route_exit': 'Väljapääs',
  'unit.m2': 'm²',

  // Языковое меню (самоназвания — одинаковы во всех словарях)
  'lang.name_ru': 'Русский',
  'lang.name_en': 'English',
  'lang.name_et': 'Eesti',

  // Kaardistiili menüü (26.07.2026)
  'basemap.title': 'Kaardi stiil',
  'basemap.style_dark': 'Tume',
  'basemap.style_cad': 'Joonis',
  'basemap.style_liberty': 'Klassikaline',
  'basemap.style_bright': 'Hele',
  'basemap.style_fiord': 'Fjord',
  'basemap.style_saved': 'Salvestatud kaart',
  // Ei sõltu ühest kaardipakkujast (24.09.2026): Maa-ameti orto ja kaart
  // ainult Eesti lähedal; «Skeem» — täiesti võrguühenduseta.
  'basemap.style_ortho': 'Ortofoto',
  'basemap.style_eemap': 'Eesti kaart',
  'basemap.style_plain': 'Skeem',
  'basemap.fallback_notice': 'Aluskaart ei toimi — lülitusime varukaardile',
  'floor.all': 'Kõik korrused',

  // Otsingupalett (referents (7), 26.07.2026)
  'search.tab_all': 'Kõik',
  'search.tab_tenants': 'Rentnikud',
  'search.tab_buildings': 'Hooned',
  'search.tab_infra': 'Taristu',
  'search.open_now': 'Praegu avatud',
  'search.quick_title': 'Kiirotsingud',
  'search.quick_food': 'Kus süüa',
  'search.quick_warehouse': 'Laod ja väljastus',
  'search.quick_dock': 'Veokirambid',
  'search.quick_entrance': 'Hoonete sissepääsud',
  'search.quick_parking': 'Parkla',
  'search.quick_checkpoint': 'Kontrollpunktid',
  'search.quick_milk': 'Piim',
  'search.quick_bread': 'Leib',
  'search.quick_checkout': 'Kassad',
  'search.quick_wc': 'WC',
  'search.tab_products': 'Tooted',

  'shopping.kicker': 'Minu nimekiri',
  'shopping.title': 'Ostunimekiri',
  'shopping.empty': 'Nimekiri on tühi. Leia toode otsingust ja vajuta „+".',
  'shopping.add': 'Lisa nimekirja',
  'shopping.remove': 'Eemalda nimekirjast',
  'shopping.clear': 'Tühjenda nimekiri',
  'shopping.tour_btn': 'Käi kõik läbi ({n})',
  'shopping.tour_hide': 'Peida marsruut',
  'shopping.stops_n': '{n} peatust',
  'shopping.share': 'Jaga nimekirja',
  'shopping.share_copied': 'Link kopeeritud',
  'shopping.promo_title': 'Praegu soodushinnaga',
  'target.add_to_list': 'Lisa ostunimekirja',
  'target.in_list': 'Nimekirjas',
  'target.usually_here': 'Tavaliselt saadaval siin',
  'search.open_badge': 'Avatud',
  'search.closed_badge': 'Suletud',
  'search.floor_n': '{n}. k',
  'search.route_btn': 'Koosta marsruut',
  'search.hint_open': 'ava',
  'search.hint_route': 'marsruut',
  'search.found_n': 'Leitud: {n}',
  'search.smart_hint':
    'Otsing mõistab kirjavigu, ladina tähti ja valet klaviatuuripaigutust. Proovi «kohvik», «ladu» või «ramp».',

  // Üksikasjalik kaart (27.07.2026)
  'card.floor_n': '{n}. korrus',
  'card.floors_n': 'Korruseid: {n}',
  'card.tenants_n': 'Rentnikke: {n}',
  'card.tenants_title': 'Rentnikud',
  'card.how_to_find': 'Kuidas sees leida',
  'card.edit_link': 'Muuda kabinetis',

  'search.all_objects': 'Kõik objektid',
  'catalog.title': 'Kataloog',
  'catalog.tenants': 'Firmad',
  'catalog.buildings': 'Hooned',
  'catalog.hover_hint': 'Hõlju real — objekt süttib kaardil',
  'catalog.other': 'Muu',
  'catalog.filter_placeholder': 'Filter: nimi või kategooria…',
  'card.photo_n': 'Foto {n}',
  'card.more': 'Rohkem infot',
  'card.less': 'Peida üksikasjad',
  'floorstack.title': 'Hoone korrused',
  'volume3d.kpi_floor': 'Korrus',
  'volume3d.kpi_area': 'Pindala',
  'volume3d.interior': 'Interjöör',
  'volume3d.outside': 'Väljast',
  'volume3d.route_here': 'Teekond joonistatud hoone sees',
  'volume3d.tenants_on_floor': 'Selle korruse üürnikud',
  'volume3d.kpi_cabin': 'Kajut',
  'cabin.interior': 'Sisekajut',
  'cabin.oceanview': 'Meievaatega',
  'cabin.balcony': 'Rõduga',
  'cabin.suite': 'Sviit',
  'cabin.port': 'Vasak parras',
  'cabin.starboard': 'Parem parras',
  'volume3d.search': 'Otsi rentnikku või kajutit',
  'volume3d.kpi_guests': 'Kohti',
  'volume3d.route_len': 'Kõnni sellel korrusel {m} m',
  'volume3d.route_none': 'Sellel korrusel läbi ei pääse — vaata marsruuti kaardil',
  'volume3d.all': 'Kõik',
  'volume3d.search_short': 'Otsi',
  'volume3d.search_empty': 'Midagi ei leitud — proovi teist sõna',
  'volume3d.search_more': 'Näidatud {shown} / {total}',
  'volume3d.search_count': 'Leitud: {n}',
  'mall.all_short': 'Kõik korrused',
  'mall.all_tab': 'Kõik',
  'mall.tab_aria': 'Korrused: praegu {floor}. Puuduta, et valida korrus',
  'volume.choose': 'Vali ruumivaade',
  'volume.kind_iso': 'Ruum',
  'volume.kind_iso_hint': 'Kogu asukoht, korrused kõrvuti',
  'volume.kind_stack': 'Korruste virn',
  'volume.kind_stack_hint': 'Hoone korrused kaardil virnas',
  'volume.kind_three': 'Ruum 3D',
  'volume.kind_three_hint': 'Korrus seest, rentnikega',
  'volume3d.open': '3D-vaade',
  'volume3d.title': 'Hoone 3D-vaates',
  'volume3d.floor_n': '{n}. korrus',
  'volume3d.explode': 'Aja korrused laiali',
  'volume3d.reset': 'Lähtesta vaade',
  'volume3d.downgraded': 'Lihtsustasime pilti, et see selles seadmes sujuvalt töötaks.',
  'volume3d.failed': '3D-vaade ei käivitunud selles seadmes — saadaval on lame «Maht».',
  'floorstack.open': 'Ruumvaade · {n} k.',
  'floorstack.vacant': 'Korrusel {n} üürnikke pole',
  'floorstack.hint': 'Korruse valik — puuduta korrust kaardil või kiipi',
  // ── hazards: точечные опасности, городская тревога (24.09.2026); staff.* — пакет strings/staff ──
  'route.detour': 'Ümbersõit: {kind} · +{m} m',
  'route.detour_floor': 'Ümbersõit: {kind}, korrus {level} · +{m} m',
  'route.detour_no_m': 'Ümbersõit: {kind}',
  'route.detour_floor_no_m': 'Ümbersõit: {kind}, korrus {level}',
  'route.detour_zone': 'ohuala',
  'route.unreachable': 'Sihtkohta ei pääse — {kind}',
  'alarm.city_label': 'Linn',
  'alarm.title_short': 'HÄIRE',
  'alarm.city_elsewhere': 'Linnahäire teises piirkonnas',
  'alarm.city_elsewhere_out': 'Linnahäire teises piirkonnas — olete sellest väljas',
  'alarm.city_elsewhere_open': 'Lähemalt',
  'alarm.drill_tag': 'ÕPPUS',
  'alarm.venue.fire': 'Tulekahju — järgige kaardil kuvatud väljapääsuteed',
  'alarm.venue.evac': 'Evakuatsioon — järgige kaardil kuvatud väljapääsuteed',
  'alarm.venue.flood': 'Üleujutus — liikuge kaardil kuvatud teed pidi ülemistele korrustele',
  'alarm.venue.danger': 'Oht — järgige personali juhiseid',
  'alarm.venue.shelter': 'Jääge hoonesse — liikuge akendest eemale',
  'alarm.city.air': 'Õhuhäire — minge varjumiskohta',
  'alarm.city.evac': 'Piirkonna evakuatsioon — järgige ametkondade juhiseid',
  'alarm.levels': 'Häire: korrus {name}',
  'alarm.checked_ago': 'Kontrollitud {min} min eest',
  'alarm.checked_now': 'Kontrollitud just nüüd',
  'alarm.offline': 'Ühendus puudub — kuvatakse viimane teadaolev signaal',
  'alarm.self_title': 'Lülitasite selle sisse ise — ametlikku signaali ei ole',
  'alarm.relay_title': 'Häire edastati teiselt telefonilt — ehtsust pole kontrollitud',
  // ── sos: всегда видимые аварийные кнопки, офлайн-статус, публичные укрытия (24.09.2026) ──
  'sos.button': 'SOS',
  'sos.sheet_title': 'Mida on vaja?',
  'sos.shelter': 'Varjumiskoht',
  'sos.exit': 'Väljapääs',
  'sos.call112': '112',
  'sos.disclaimer': 'Need nupud ei teavita kedagi — need näitavad teed ainult teile endale.',
  'sos.status_offline': 'Ühendust pole — kaart töötab võrguühenduseta',
  'sos.status_checked': 'Ametlikku signaali ei ole · kontrollitud {n} min tagasi',
  'sos.status_unknown': 'Ametlikku signaali ei ole',
  'shelters.geo_asking': 'Määrame teie asukoha, et näidata lähimat varjumiskohta',
  'shelters.geo_denied': 'Asukohale ligipääs puudub — nimekiri linna keskpunktist',
  'shelters.straight_line': 'sirgjoon — tee võib olla pikem',
  'shelters.route_btn': 'Marsruut',
  'shelters.none': 'Läheduses varjumiskohti ei leitud',
  'cityalert.air': 'Õhuhäire',
  'cityalert.evac': 'Evakuatsioon',
  'cityalert.drill_badge': 'ÕPPUS · УЧЕНИЯ',
  'cityalert.finding_you': 'Määrame teie asukoha, et näidata teed lähima varjumiskohani',
  // ── hazard-map: обход опасностей обычным маршрутом, зона опасности на карте (24.09.2026) ──
  'hazard.kind.fire': 'Tulekahju',
  'hazard.kind.smoke': 'Suits',
  'hazard.kind.flood': 'Üleujutus',
  'hazard.kind.danger': 'Oht',
  'hazard.kind.closed': 'Läbipääs suletud',
} as const
